/**
 * Captures the guest access token from `/p#<token>` and strips it from the URL before any other
 * module evaluates (ADR-001 Amendment 1). Imported as the FIRST line of `main.tsx`, ahead of
 * `./instrument` — Sentry's `browserTracingIntegration` and breadcrumb capture must never see the
 * raw token in `location.href`.
 *
 * The token lives in a module-level closure only: no `localStorage`/`sessionStorage`/cookie/global
 * write. `history.replaceState` removes the fragment from the visible URL and browser history
 * without a navigation (so the back button never re-reveals the token), but is not a "storage"
 * write in the sense this module's contract forbids.
 */

let capturedToken: string | null = null;

if (window.location.pathname === '/p' && window.location.hash.length > 1) {
  capturedToken = window.location.hash.slice(1);
  window.history.replaceState(window.history.state, '', '/p');
}

/** Returns the captured token, or `null` if `/p` was loaded without a fragment. */
export function takeGuestToken(): string | null {
  return capturedToken;
}

/** Clears the captured token (e.g. after it has been exchanged for a session). */
export function forgetGuestToken(): void {
  capturedToken = null;
}
